import { createContext } from 'react';
import type { Plugins } from '../plugins/Plugins';

type TelemetryContext = {
  isReady: boolean;
  getPluginCtx: <T extends keyof Plugins>(pluginName: T) => Plugins[T];
};

export const telemetryCtx = createContext<TelemetryContext>(undefined as unknown as TelemetryContext);
